<template>
  <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="page" :page-sizes="size_list"
    :page-size="size" layout="total, sizes, prev, pager, next, jumper" :total="total">
  </el-pagination>
</template>

<script>
  export default {
    created() {
      this.getTotalsize();
    },
    methods: {
      async getTotalsize(keyword) {
        let params = {};
        if (keyword) {
          params.options = [{
            "type": "8",
            "name": "detail",
            "value": keyword
          }];
          if (keyword != "" && !isNaN(keyword)) {
            params.options.push({
              "type": "1",
              "name": "id",
              "value": keyword
            });
            params.operator = " OR ";
          }
        }
        // this.$getJSON("/task/cnt_period_tasklst", params).then(res => {
        //   this.total = res.data[0].count;
        //   if (this.page > Math.ceil(this.total / this.size)) {
        //     this.page = Math.ceil(this.total / this.size);
        //   }
        // });
        let res = await this.$getJSON("/task/cnt_period_tasklst", params);
        this.total = res.data[0].count;
        if (this.page > Math.ceil(this.total / this.size)) {
          this.page = Math.ceil(this.total / this.size);
        }
      },
      handleSizeChange(a) {
        this.size = a;
        if (this.page > Math.ceil(this.total / this.size)) {
          this.page = Math.ceil(this.total / this.size);
        }
        this.$emit("change", {
          page: this.page,
          size: this.size
        });
      },
      handleCurrentChange(a) {
        this.page = a;
        this.$emit("change", {
          page: this.page,
          size: this.size
        });
      }
    },
    data() {
      return {
        page: 1,
        size_list: [10, 20, 30, 40],
        size: 10,
        total: 400
      };
    }
  };

</script>

<style scoped>
  .el-pagination {
    text-align: center;
  }

</style>



// WEBPACK FOOTER //
// src/components/PeriodTask/PageNation.vue